
import Button from "@/components/base/Button"

import {
    mdiChevronLeft,
    mdiBookmarkCheckOutline,
    mdiBookmarkOutline,
    mdiThumbsUpDown,
    mdiThumbsUpDownOutline,
} from "@mdi/js"
import { mapGetters } from "vuex"
import {
    routeToBusiness,
    routeToRegionChannel,
    routeToBusinessSite,
} from "@/helpers/routing"

export default {
    name: "DetailsPageToolbar",
    components: {
        SVGGradient: () => import("@/components/base/design/SVGGradient"),
        BusinessLogo: () => import("@/components/business/BusinessLogo"),
        ShareSpeedModal: () => import("@/components/base/ShareSpeedModal"),
        EmojiRatingMenu: () =>
            import("@/components/base/input/EmojiRatingMenu"),
        Button,
    },
    icons: {
        mdiChevronLeft,
        mdiThumbsUpDown,
        mdiThumbsUpDownOutline,
        mdiBookmarkOutline,
        mdiBookmarkCheckOutline,
    },
    props: {
        showToolbar: {
            type: Boolean,
            default: false,
        },
        app: {
            type: Boolean,
            default: false,
        },
        inSplitscreen: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        loadingBack: false,
        isRatingMenuOpen: false,
    }),
    computed: {
        ...mapGetters("routing", ["previousRoute"]),
        ...mapGetters("meta", ["meta"]),
        routeToBusiness() {
            if (this.displayedDetail.business?.is_site_management_enabled) {
                return routeToBusinessSite(this.displayedDetail.business_site)
            } else {
                return routeToBusiness(this.displayedDetail.business)
            }
        },
        backButtonLabel() {
            if (this.googleJobsRouting) {
                return "Zur Übersicht"
            } else {
                return "Zurück"
            }
        },
        googleJobsRouting() {
            return (
                this.$route.query.utm_campain === "google_jobs_apply" ||
                this.$route.query.utm_source === "google_jobs_apply"
            )
        },
        displayedDetail() {
            const type = this.meta.toolbar?.detailType

            if (type === "job") {
                return this.$store.getters["job/displayedJob"]
            }
            if (type === "post") {
                return this.$store.getters["post/displayedPost"]
            }
            if (type === "business") {
                const business =
                    this.$store.getters["business/displayedBusiness"]
                return {
                    business: business.baseInfo,
                    id: business.baseInfo.id,
                }
            }
            if (type === "school") {
                const school = this.$store.getters["school/displayedSchool"]
                return {
                    school: school.baseInfo,
                }
            }
            return {}
        },
        showBusinessLogo() {
            return (
                this.$breakpoint.mdAndUp &&
                this.displayedDetail &&
                this.displayedDetail.business &&
                this.meta.toolbar?.detailType !== "business"
            )
        },
    },
    methods: {
        back() {
            if (this.loadingBack) return
            if (this.inSplitscreen) {
                this.$emit("close-splitscreen")
                return
            }
            this.loadingBack = true

            if (this.previousRoute) {
                this.$store.dispatch("routing/back")
                this.loadingBack = false
                return
            }
            if (this.displayedDetail) {
                let route = this.$store.getters["search/route"]({
                    category: "Ausbildung",
                    slug: "nearby",
                })
                const businessPrimaryAddress =
                    this.displayedDetail.business?.primary_address
                if (businessPrimaryAddress) {
                    route.query = {
                        longitude: businessPrimaryAddress.lng,
                        latitude: businessPrimaryAddress.lat,
                    }
                } else if (this.displayedDetail.author) {
                    const authorPrimaryAddress =
                        this.displayedDetail.author?.primary_address
                    const authorType = this.displayedDetail.author_type
                    if (authorType === "business" && authorPrimaryAddress) {
                        route.query = {
                            longitude: authorPrimaryAddress.lng,
                            latitude: authorPrimaryAddress.lat,
                        }
                    } else if (authorType === "region") {
                        route = routeToRegionChannel()
                    }
                }
                this.$router.push(route)
                this.loadingBack = false
                return
            }
            this.$router.push("/")
            this.loadingBack = false
        },
    },
}
